import {
    FEEDBACK_SUBMIT_REQUEST,
    FEEDBACK_SUBMIT_SUCCESS,
    FEEDBACK_SUBMIT_FAILURE,
    FEEDBACKS_FETCH_REQUEST,
    FEEDBACKS_FETCH_SUCCESS,
    FEEDBACKS_FETCH_FAILURE,
    FEEDBACK_FETCH_REQUEST,
    FEEDBACK_FETCH_SUCCESS,
    FEEDBACK_FETCH_FAILURE,
    FEEDBACK_STATUS_UPDATE_REQUEST,
    FEEDBACK_STATUS_UPDATE_SUCCESS,
    FEEDBACK_STATUS_UPDATE_FAILURE,
    FEEDBACK_DELETE_REQUEST,
    FEEDBACK_DELETE_SUCCESS,
    FEEDBACK_DELETE_FAILURE
} from '../actions/feedback';

const initialState = {
    feedbacks: [],
    currentFeedback: null,
    loading: false,
    error: null,
    submitSuccess: false
};

const feedbackReducer = (state = initialState, action) => {
    switch (action.type) {
        // Submit Feedback Form
        case FEEDBACK_SUBMIT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                submitSuccess: false
            };
        case FEEDBACK_SUBMIT_SUCCESS:
            return {
                ...state,
                loading: false,
                submitSuccess: true,
                error: null
            };
        case FEEDBACK_SUBMIT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                submitSuccess: false
            };

        // Fetch All Feedbacks
        case FEEDBACKS_FETCH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FEEDBACKS_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbacks: action.payload,
                error: null
            };
        case FEEDBACKS_FETCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Fetch Single Feedback
        case FEEDBACK_FETCH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FEEDBACK_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                currentFeedback: action.payload,
                error: null
            };
        case FEEDBACK_FETCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Update Feedback Status
        case FEEDBACK_STATUS_UPDATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FEEDBACK_STATUS_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbacks: state.feedbacks.map(feedback => 
                    feedback._id === action.payload.feedback._id 
                        ? action.payload.feedback 
                        : feedback
                ),
                currentFeedback: action.payload.feedback,
                error: null
            };
        case FEEDBACK_STATUS_UPDATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Delete Feedback
        case FEEDBACK_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FEEDBACK_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbacks: state.feedbacks.filter(feedback => feedback._id !== action.payload),
                currentFeedback: null,
                error: null
            };
        case FEEDBACK_DELETE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default feedbackReducer; 